export const PostEditorRoute = {
  PostEditor: 'post-editor'
} as const;

export type PostEditorRoute =
  (typeof PostEditorRoute)[keyof typeof PostEditorRoute];

export type PostEditorParam = {
  [PostEditorRoute.PostEditor]: { id: string };
};
